import * as React from 'react';
import { RouteComponentProps , withRouter} from 'react-router';
import { Col, Collapse, Row } from 'reactstrap';
import { CVModal } from 'src/components/shared/Modals/CVModal';
import { Svg } from 'src/components/shared/Svg';
import { currency } from 'src/config';
import { IGlobalContextProps, withGlobalContext,} from 'src/context/global.context';
import { IProject, IProposition, IStep, IUser  } from 'src/model';
import { acceptProposition, getProject, getUser, rejectProposition, shortlistProposition} from 'src/services';
import { ProjectPropositionCardActions } from './ProjectPropositionCardActions';
import { ProjectPropositionCardFiles } from './ProjectPropositionCardFiles';
import { ProjectPropositionCardStep } from './ProjectPropositionCardStep';

interface IProjectPropositionCardProps {
  proposition: IProposition;
  handlePropositionListChange?: () => void;
  handleProjectChange?: (project : IProject) => void;
}

interface IProjectPropositionCardState {
  consultant: IUser | null;
  CVModalIsOpen: boolean;
  isOpen: boolean;
  project: IProject | null;
}

class ProjectPropositionCard extends React.Component<
  IProjectPropositionCardProps & IGlobalContextProps & RouteComponentProps,
  IProjectPropositionCardState
> {
  public constructor(
    props: IProjectPropositionCardProps & IGlobalContextProps & RouteComponentProps
  ) {
    super(props);
    this.state = {
      CVModalIsOpen: false,
      consultant: null,
      isOpen: false,
      project: null,
    };
  }
 
  public toggleCVModal = () =>
    this.setState({
        CVModalIsOpen: !this.state.CVModalIsOpen,
    });

  public handlePropositionChange = async (action: string) => {
    const { context,handleProjectChange, handlePropositionListChange, proposition  } = this.props;

    if(action === 'shortlist'){
      await shortlistProposition(proposition._id)
    } else if  (action === 'reject'){
      await rejectProposition(proposition._id)
    }
    else{
      await acceptProposition(proposition._id);
    }
    

    const updatedProject = proposition && (await getProject((proposition as IProposition).project._id));

    if (updatedProject) {
      if (typeof handleProjectChange === 'function') {
        handleProjectChange(updatedProject);
      }
      context.updateProject(updatedProject);
      if (typeof handlePropositionListChange === 'function') {
        handlePropositionListChange();
      }
    }

    if(action === 'accept'){
       const projectId = updatedProject._id
       this.props.history.push(`/project/${projectId}/workspace`);
    //   // const pathname = location.pathname.replace(`/consultants`, '/workspace');
    //   // history.push(pathname);
     }
  };

  public toggleCollapse = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  public async componentDidUpdate(nextProps: IProjectPropositionCardProps) {
    if (
      this.props.proposition.consultantId !== nextProps.proposition.consultantId
    ) {
      const { proposition } = this.props;
      const consultant = await getUser(proposition.consultantId);
      if (consultant) {
        this.setState({ consultant });
      }
    }
  }

  public async componentDidMount() {
    const { proposition } = this.props;
    const consultant = await getUser(proposition.consultantId);
    if (consultant) {
      this.setState({ consultant });
    }
  }

  public render() {
    const { user } = this.props.context;
    const { proposition } = this.props;
    const { consultant, isOpen } = this.state;
    const pictureUrl =
      consultant &&
      consultant.profile.picture &&
      consultant.profile.picture.pictureUrl;

    return (
      proposition && (
        <Row className='mb-4'>
          <Col className='d-flex flex-column align-items-center' md='2'>
            {pictureUrl ? (
              <img
                className='d-block rounded-circle'
                src={pictureUrl}
                style={{ height: '80px', width: '80px' }}
              />
            ) : (
              <div
                className='d-flex justify-content-around rounded-circle bg-primary'
                style={{ height: '80px', width: '80px' }}
              >
                <Svg width={36} fill='white' src='user' />
              </div>
            )}
            <div className='mt-3'  onClick={this.toggleCVModal} >
              {consultant &&
                `${(consultant as IUser).firstname} ${
                  (consultant as IUser).lastname[0]
                }
                .`}
            </div>
              <CVModal 
                isOpen={this.state.CVModalIsOpen}
                toggleCVModal={this.toggleCVModal}
                consultant={consultant as IUser}
              />
          </Col>
          <Col md='10'>
            <Row className='position-relative d-flex justify-content-between rounded bg-white p-3'>
              <Col md='9'>
                <Row className='d-flex flex-column'>
                  <div className='d-flex align-items-center mb-4'>
                    <span
                      className='text-secondary'
                      style={{ fontSize: '22px' }}
                    >
                      {`${
                        proposition.finalDailyPrice
                          ? proposition.finalDailyPrice
                          : '-'
                      }
            ${currency[proposition.currency]}/jour`}
                    </span>
                    <span className='dot bg-secondary ml-3 mr-3' />
                    <span
                      className='text-secondary'
                      style={{ fontSize: '22px' }}
                    >
                      {`${proposition.finalPrice ? proposition.finalPrice : '-'}
            ${currency[proposition.currency]}/global`}
                    </span>
                  </div>
                  <span>{proposition.title}</span>
                  <p className='position-relative p-4'>
                    <Svg
                      className='position-absolute'
                      width={80}
                      height={80}
                      fill='secondary'
                      opacity={0.25}
                      src='quotation'
                      style={{
                        left: '-10px',
                        top: '-10px',
                        transform: 'scaleX(-1)',
                      }}
                    />
                    {proposition.description}
                    <Svg
                      className='position-absolute'
                      width={80}
                      height={80}
                      fill='secondary'
                      opacity={0.25}
                      src='quotation'
                      style={{
                        bottom: '-10px',
                        right: '-10px',
                      }}
                    />
                  </p>
                </Row>
              </Col>
              <Col className='d-flex flex-column align-items-center' md='3'>
                {proposition.sendingDate && (
                  <>
                    <span className='mb-1'>Profil proposé le</span>
                    <span
                      className='font-weight-bold mb-3'
                      style={{ fontSize: '18px' }}
                    >
                      {new Date(proposition.sendingDate).toLocaleDateString()}
                    </span>
                  </>
                )}
                {proposition.choosingDate && (
                  <>
                    <span className='text-warning mb-1'>Profil choisi le</span>
                    <span
                      className='text-warning font-weight-bold mb-3'
                      style={{ fontSize: '18px' }}
                    >
                      {new Date(proposition.choosingDate).toLocaleDateString()}
                    </span>
                  </>
                )}
                {user && user.type === 'client' ? (
                  <ProjectPropositionCardActions
                    status={proposition.meta.status}
                    handlePropositionChange={this.handlePropositionChange}
                  />
                ) : null}
              </Col>
              <Col md={`12 ${proposition.files.length ? 'mb-5' : ''}`}>
                {proposition.stepList.length || proposition.files.length ? (
                  <>
                    <Row className='d-flex justify-content-end mt-3'>
                      <Col
                        className='text-right'
                        md='3'
                        onClick={this.toggleCollapse}
                      >
                        <span className='text-uppercase mr-2'>
                          {isOpen ? 'Fermer' : 'Consulter le détail'}
                        </span>
                        <Svg
                          width={12}
                          fill='primary'
                          src='down'
                          style={{
                            transform: isOpen
                              ? 'rotate(180deg)'
                              : 'rotate(0deg)',
                          }}
                        />
                      </Col>
                    </Row>
                    <Collapse
                      className='border-top border-secondary mt-3'
                      isOpen={isOpen}
                    >
                      {proposition.stepList.map((step: IStep, key: number) => (
                        <ProjectPropositionCardStep key={key} step={step} />
                      ))}
                    </Collapse>
                  </>
                ) : null}
              </Col>
              {proposition.files.length ? (
                <ProjectPropositionCardFiles
                  propositionId={proposition._id}
                  files={proposition.files}
                />
              ) : null}
            </Row>
          </Col>
        </Row>
      )
    );
  }
}

export const ProjectPropositionCardWithGlobalContext = withGlobalContext(withRouter(ProjectPropositionCard));


// WEBPACK FOOTER //
// ./src/components/Project/ProjectPropositions/ProjectPropositionCard/ProjectPropositionCard.tsx